import { createApi } from '@reduxjs/toolkit/query/react'

import { getBaseQueryWithMockError } from '@/shared/api/custom-fetch-base'

import { ISettings } from '../model/types'

const mock = [
  {
    officeId: 15,
    updateFreequencyValue: 1,
    updateFreequencyUnit: 'hour',
    notify: true,
    notifyPhone: '+79991112233',
    notifyFreequency: 'h',
    storagePeriod: 1,
  },
  {
    officeId: 16,
    updateFreequencyValue: 1,
    updateFreequencyUnit: 'day',
    notify: false,
    storagePeriod: 2,
  },
  {
    officeId: 17,
    updateFreequencyValue: 1,
    updateFreequencyUnit: 'hour',
    notify: true,
    notifyPhone: '+79991112233',
    notifyFreequency: 'd',
    storagePeriod: 3,
  },
]

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: getBaseQueryWithMockError(mock),
  tagTypes: ['settings'],
  endpoints: build => ({
    settings: build.query<ISettings, number>({
      query: officeId => ({
        url: `/user/settings/${officeId}`,
        method: 'GET',
      }),
      providesTags: ['settings'],
    }),

    updateSettings: build.mutation<
      ISettings,
      { officeId: number; body: ISettings }
    >({
      query: ({ officeId, body }) => ({
        url: `/user/settings/${officeId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['settings'],
    }),

    removeSettings: build.mutation<unknown, number>({
      query: officeId => ({
        url: `/user/settings/${officeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['settings'],
    }),
  }),
})

export const {
  useSettingsQuery,
  useUpdateSettingsMutation,
  useRemoveSettingsMutation,
} = settingsApi
